import * as angular from "angular";
import {IController, IIntervalService, IScope} from "angular";
import * as _ from "lodash";
import {AnalyticsService} from "../../modules/commons/services/analytics-service.service";
import {SyncService} from "../../modules/persistence-layer/sync-service.service";
import {CommonsDialogService} from "../../modules/commons/services/commons-dialog.service";
import {ConfirmChangeStateService} from "../../modules/commons/services/confirm-change-state.service";
import {ConfirmDialogService} from "../../modules/commons/services/confirm-dialog.service";
import {SiteContextService} from "../../modules/commons/services/site-context.service";
import {EnvironmentType} from "../../modules/commons/types/environment.type";
import {SplitService} from "../../modules/commons/services/split-service.service";
import {TranslateService} from "@ngx-translate/core";
import {TranslationsService} from "../../modules/commons/angular/services/translations.service";
import {Inject} from "@angular/core";
import {CommonsFacadeService} from "../../modules/commons/angular/state/commons/commons-facade.service";
import {Observable, Subscription} from "rxjs";
import {AddressFacadeService} from "../../modules/addresses/angular/state/addresses-facade.service";

export class RootComponentCtrl implements IController {

  maps: any;
  onDeleteSite: Function;

  public environmentTypes: typeof EnvironmentType = EnvironmentType;
  public environment: EnvironmentType;
  public isSuperOwner: boolean;
  public loadingQueue: any;
  public showLoader: boolean;
  public loading: boolean;
  public isChatOpen: boolean = false;
  public isEnvRowDisplay: boolean = true;
  public loaderStateSubscription: Subscription;
  public isLoading: boolean;


  /* @ngInject */
  constructor(private $scope: IScope, private confirmChangeStateService: ConfirmChangeStateService, private commonsDialogService: CommonsDialogService, private triSkins,
              private uiGmapIsReady, private confirmDialogService: ConfirmDialogService, private $state, private $log, private analyticsService: AnalyticsService,
              private $mdDialog, private siteContextService: SiteContextService, private syncService: SyncService, private IAMPermissions, private $timeout,
              private apiConfig, private translationsService: TranslationsService, private commonsFacadeService: CommonsFacadeService,
              private addressFacadeService: AddressFacadeService) {
  }

  $onInit() {

    if (typeof google !== 'undefined' && google.maps?.InfoWindow?.prototype) {
      Object.defineProperty(google.maps.InfoWindow.prototype, "isOpen", {
        value: function () {
          return !!this._isOpen;
        },
        writable: true, // Ensures it behaves like a function
      });
    }

    this.loaderStateSubscription = this.commonsFacadeService.selectLoader().subscribe((isLoading) => {
      this.isLoading = isLoading;
      this.$timeout(() => {}, 0);
    });

    const languageFlavor = this.siteContextService.isSite() ?
      this.siteContextService.getSiteInfo().languageFlavor : undefined;
    this.translationsService.setTranslations(localStorage.getItem('NG_TRANSLATE_LANG_KEY'), languageFlavor);

    this.environment = this.apiConfig.env;
    this.isSuperOwner = this.IAMPermissions.hasRole('super.owner');

    this.loadingQueue = [];
    this.showLoader = false;
    this.loading = false;

    // register listeners for loader
    this.$scope.$on('loader', this.loaderEvent.bind(this));

    // watch for ui router state change start
    this.$scope.$on('$stateChangeStart', this.stateChangeStart.bind(this));

    // watch for ui router state change end - Success
    this.$scope.$on('$stateChangeSuccess', this.stateChangeEnd.bind(this));

    // watch for ui router state change end - Error
    this.$scope.$on('$stateChangeError', this.stateChangeEnd.bind(this));

    // watch for view content loading
    this.$scope.$on('$viewContentLoading', this.viewContentLoading.bind(this));

    // watch for view content loaded
    this.$scope.$on('$viewContentLoaded', this.viewContentLoaded.bind(this));

    // watch for bringoz manual loading
    // this.$scope.$on('$bringozLoading', this.onBringozLoading.bind(this));
  }

  $onDestroy() {
    this.loaderStateSubscription.unsubscribe();
  }

  onCloseEnvIndication() {
    this.isEnvRowDisplay = false;
  }


  loaderEvent(event, isActive) {
    this.showLoader = isActive;
  }

  stateChangeStart(event, toState, toParams, fromState, fromParams) {
    // state has changed so start the loader

    const siteInfo = this.siteContextService.isSite() ? this.siteContextService.getSiteInfo() : undefined;
    const isConfirmNeeded = this.confirmChangeStateService.getIsEnabled();

    if (isConfirmNeeded && !_.get(siteInfo, 'suspended')) {
      const transitionApproved = this.confirmChangeStateService.getHasTransitionApproved();
      if (!transitionApproved) {
        event.preventDefault();
        const isDialogActive = this.confirmChangeStateService.getIsDialogActive();
        if (!isDialogActive) {
          this.confirmChangeStateService.setIsDialogActive(true);
          this.confirmDialogService.confirmState(event)
            .then(() => {
              this.confirmChangeStateService.setHasTransitionApproved(true);
              this.showLoader = true;
              this.$state.go(toState, toParams);
              this.analyticsService.trackEvent('Common', 'Leave Page', 'Confirm', fromState.name);
            })
            .catch(() => {
              this.analyticsService.trackEvent('Common', 'Leave Page', 'Cancel', fromState.name);
              this.$log.info('Dialog Closed');
            })
            .finally(() => {
              this.confirmChangeStateService.setIsDialogActive(false);
            })
        }
      }
    } else {
      this.loading = true;
    }
  }

  stateChangeEnd() {
    this.loading = false;

    const siteInfo = this.siteContextService.isSite() ? this.siteContextService.getSiteInfo() : undefined;
    this.addressFacadeService.setAddressId();

    if (!_.get(siteInfo, 'suspended')) {

      this.syncService.firebaseGoOnline();
      // Only cancel when a dialog is actually present - a blanket $mdDialog.cancel() on every
      // navigation races against any unrelated dialog that's still mid-show() elsewhere in the app
      // (e.g. planning's websocket-driven optimize loaders), which can leave the body stuck with the
      // "md-dialog-is-showing" class and no dialog to show for it.
      if (document.querySelector('md-dialog')) {
        this.$mdDialog.cancel();
      }
      this.removeStaleDialogShowingClass();
    } else {
      this.commonsDialogService.suspendSite()
    }
  }

  // Defensive cleanup: if a previous dialog's teardown got interrupted (e.g. by the race described
  // above), the body is left with "md-dialog-is-showing" but no actual dialog in the DOM, which
  // silently no-ops every future $mdDialog.show() call. Clear it on every navigation so the app
  // self-heals instead of requiring a manual page reload.
  removeStaleDialogShowingClass() {
    if (!document.querySelector('md-dialog') && document.body.classList.contains('md-dialog-is-showing')) {
      document.body.classList.remove('md-dialog-is-showing');
    }
  }

  viewContentLoading($event, viewName) {
    // a view is loading so add it to the queue
    // so we know when to turn off the loader
    this.loadingQueue.push(viewName);
  }

  // onBringozLoading(event, isLoading) {
  //   this.loading = isLoading || false;
  // }

  viewContentLoaded($event, viewName) {

    this.uiGmapIsReady.promise(1)
      .then((instances) => {
        instances.forEach((inst) => {
          const map = inst.map;
          this.maps.event.trigger(map, 'resize');
        });
      })
      .catch(() => {});

    // view content has loaded so remove it from queue
    const index = this.loadingQueue.indexOf(viewName);
    if (-1 !== index) {
      this.loadingQueue.splice(index, 1);
    }
    // is the loadingQueue empty?
    if (this.loadingQueue.length === 0) {
      // nothing left to load so turn off the loader
      this.showLoader = false;
      this.confirmChangeStateService.reset();
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('rootComponent', {
    bindings: {
      maps: '<',
      onDeleteSite: '&'
    },
    template: require('./root-component.html').default,
    controller: RootComponentCtrl
  });
